<template>
  <div>
    <v-radio-group v-model="selectedReport" row dense>
      <v-radio label="Sessions Not Billed" value="sessionsNotBilled"></v-radio>
      <v-radio label="Billable Units" value="billableUnits"></v-radio>
    </v-radio-group>
    <v-divider class="my-5"></v-divider>
    <sessions-not-billed
      v-if="selectedReport === 'sessionsNotBilled'"
    ></sessions-not-billed>
    <billable-units
      v-else-if="selectedReport === 'billableUnits'"
    ></billable-units>
  </div>
</template>
<script>
import SessionsNotBilled from "./sessions-not-billed.vue";
import BillableUnits from "./billable-units.vue";
export default {
  components: { SessionsNotBilled, BillableUnits },
  data() {
    return {
      selectedReport: "sessionsNotBilled",
    };
  },
};
</script>
